'use client'
import React from 'react'

import { TimelineEventProps } from './TimelineEvent'

interface TimelineProps extends React.HTMLAttributes<HTMLDivElement> {
    /** <Button> that is shown at the top of the list, i.e. "Add note" */
    action?: React.ReactElement
    /** <EmptyState> component shown when there are no "children" */
    emptyState: React.ReactElement
    /** List of <TimelineEvent> components or custom wrappers of the <TimelineEvent> component.
     * IMPORTANT NOTE: Each child gets the props "isFirst" and "isLast" added so in case of wrapper components, make sure to forward them to the TimelineEvent component */
    children: React.ReactNode
}

export const Timeline = ({ action, emptyState, children }: TimelineProps): JSX.Element => {
    const mappedChildren = React.Children.toArray(children)
        .filter((child) => !!child)
        .map((element, index, array) => {
            if (React.isValidElement(element)) {
                return React.cloneElement(element as React.ReactElement<TimelineEventProps>, {
                    isFirst: index === 0,
                    isLast: index === array.length - 1,
                })
            }
            return element
        })

    return (
        <div className="flex flex-col gap-2" data-testid="timeline">
            {action && action}
            {!mappedChildren.length && emptyState}
            {!!mappedChildren.length && <ol className="list-none flex flex-col gap-0">{mappedChildren}</ol>}
        </div>
    )
}
